import { postRequest } from ".";

export const createJusteatMenu = async (
    payload: Record<string, any>,
) => {
    const data = await postRequest(`api/justeat/menu`, payload);
    return data as any;
}